import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackPlayedVideo.meta';

export type TrackPlayedVideoParams = {
  id: string;
};

export const useTrackPlayedVideo = () => {
  const { track } = useAnalyticsUtilities();

  const trackPlayedVideo = useCallback(
    (params: TrackPlayedVideoParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackPlayedVideo };
};
